import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {Observable, catchError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationUpdateMessagesService extends DataService {

  private baseURI = this.apiUri + '/orgupdatemessages/';

  constructor(http: HttpClient) {
    super(http);
  }

  getMessages(orgId: number): Observable<any> {
    this.setUri(this.baseURI + 'get' + '/' + orgId + '/orgId');
    return this.get().pipe(catchError(this.handleError));
  }

  getApprovalMessages(orgId: number, programType: string): Observable<any> {
    this.setUri(this.baseURI + 'get' + '/' + orgId + '/orgId/' + programType + '/programType'); // {orgId}/orgId/{programType}/programType
    return this.get().pipe(catchError(this.handleError));
  }

}
